import  { getEnvVars } from '../constants';
import useWidgetStore from '../store/useWidgetStore';

export const getApiEssentials = (pathname) => {
	const config = useWidgetStore.getState().config;
	const { apiKey, hotelId, locale } = config || {};
	const baseUrl = getEnvVars().BE_SERVICE_URL;
	const apiUrl = typeof pathname === 'function'
		? pathname({ baseUrl, apiKey, hotelId, locale })
		: pathname;

	return {
		apiUrl,
		hotelId,
		apiKey,
	}
};

export const doGet = (pathname, headers = {}) => {
	const { apiUrl, hotelId, apiKey } = getApiEssentials(pathname);
	return fetch(apiUrl, {
    headers: {
      'Api-Key': apiKey,
      ...headers
    },
  });
};

export const doPost = (pathname, payload = {}, headers = {}) => {
	try {
		const { apiUrl, hotelId, apiKey } = getApiEssentials(pathname);
		return fetch(apiUrl, {
			method: 'POST',
			body: JSON.stringify(payload),
			headers: {
	      'Api-Key': apiKey,
	      'Content-Type': 'application/json',
	      ...headers
	    },
		});
	} catch (err) {
		console.error('Failed to doPost', pathname, err);
	}
}
